import { defineStore } from 'pinia';
import { useAuthStore } from './auth';
import {getAuth} from "firebase/auth";

// import OpenAI from "openai";
// const openai = new OpenAI({
//     // apiKey: process.env.OPENAI_API_KEY // Make sure this is set in Render dashboard
//     apiKey: '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'
// });

export const useConversationStore = defineStore('chatbot', {
    constructor: (chatId) => {
        console.log('Chatbot service store initialized');
        if (chatId) {
            this.chatId = chatId; // Set the chat ID if provided
        }
    },

    state: () => ({
        user: null,
        loading: true,
        chatId: null, // Current chat ID
        // Chat state
        chatHistory: []
    }),

    actions: {
        // Initialize a new chat session
        async initNewChat(botType) {
            let botId = 1;
            let userToken = await this.getUserToken();
            if (!userToken) {
                return new Response("User Token not found. Please log in.", { status: 401 });
            }

            try {
                let response = await fetch(import.meta.env.VITE_BACKEND_API_URL + '/api/conversation/new', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${userToken}`
                    },
                    credentials: 'include',

                    body: JSON.stringify({
                        'bot_id': botId
                    })
                });
                // if (!response.ok) throw new Error('Failed to save chat');

                let data = await response.json();

                this.chatId = data.conversation_id; // Set the chat ID from the response
                localStorage.setItem('latest_chat_id', this.chatId); // Store chat ID in local storage
            } catch (error) {
                console.error('Error saving chat:', error);
            }

            return new Response({
                "message": "Chat successfully created!",
                "chat_id": this.chatId,
            }, { status: 201 });
        },
        async ask(bot, question) {
            console.log('Asking question:', question + ' to bot:', bot);

            //TODO: Implement the logic to check if the user has reached their daily limit

            let conversationId = await this.getChatId();
            console.log('Current conversation ID:', conversationId);

            let userToken = await this.getUserToken();
            if (!userToken) {
                return new Response("User Token not found. Please log in.", { status: 401 });
            }

            try {
                let response = await fetch(import.meta.env.VITE_BACKEND_API_URL + '/api/conversation/' + conversationId + '/message', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${userToken}`
                    },
                    credentials: 'include',

                    body: JSON.stringify({
                        'bot_id': bot || 1,
                        'actor': 'user',
                        'content': question,
                    })
                });
                // if (!response.ok) throw new Error('Failed to save chat');

                return await response.json();
            } catch (error) {
                console.error('Error saving chat:', error);
            }
        },

        /*
         * Retrieve a list of saved conversations for the user
         */
        async getConversationHistory() {
            let userToken = await this.getUserToken();
            if (!userToken) {
                return new Response("User Token not found. Please log in.", { status: 401 });
            }

            try {
                // sleep for 1 second to ensure the chat is saved before fetching history
                // await new Promise(resolve => setTimeout(resolve, 5000));


                const response = await fetch(import.meta.env.VITE_BACKEND_API_URL + '/api/conversation/history', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${userToken}`
                    },
                    credentials: 'include'
                });

                if (!response.ok) throw new Error('Failed to save chat');

                const data = await response.json();

                if (!data || data.length === 0) {
                    return []; // return an empty array, not a Response object
                }

                this.conversationHistory = data;
                return data;

            } catch (error) {
                console.error('Error saving chat:', error);
            }

            return new Response("User saved successfully!", { status: 200 });

        },

        /*
         * Reload the history for the current conversation
         */
        async getCurrentConversationMessages(conversationId, shared = false) {
            let userToken = await this.getUserToken();
            if (!userToken) {
                return new Response("User Token not found. Please log in.", { status: 401 });
            }

            try {
                const response = await fetch(import.meta.env.VITE_BACKEND_API_URL + '/api/conversation/' + conversationId + '/history', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${userToken}`
                    },
                    credentials: 'include'
                });

                if (!response.ok) throw new Error('Failed to load conversation messages');

                const data = await response.json();

                if (!data || data.length === 0) {
                    return []; // return an empty array, not a Response object
                }
                return data;

            } catch (error) {
                console.error('Error:', error);
            }
        },

        async getSharedConversationMessages(conversationId) {
            try {
                const response = await fetch(import.meta.env.VITE_BACKEND_API_URL + '/api/conversation/' + conversationId + '/shared', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include'
                });

                if (!response.ok) throw new Error('Failed to load shared conversation messages');

                const data = await response.json();

                if (!data || data.length === 0) {
                    return []; // return an empty array, not a Response object
                }
                return data;

            } catch (error) {
                console.error('Error:', error);
            }
        },


        async setChatId(chatId) {
            this.chatId = chatId;
            localStorage.setItem('latest_chat_id', chatId); // Store chat ID in local storage

            return this;
        },
        async getChatId() {
            if(localStorage.getItem('latest_chat_id')) {
                // this.chatId = localStorage.getItem('latest_chat_id');
            }

            if (this.chatId) {
                return this.chatId;
            }

            // this.initNewChat('general');
            return this.chatId ?? {};
        },
        async getUserToken() {
            const authStore = useAuthStore();
            let token = null;
            if(localStorage.getItem('auth_user_token')) {
                let lsToken = localStorage.getItem('auth_user_token');

                if (authStore.user && authStore.user.getIdToken) {
                    token = await authStore.user.getIdToken();
                } else if (authStore.user && authStore.user.accessToken) {
                    token = authStore.user.accessToken;
                } else {
                    console.warn('User token not available');
                }
                // console.warn('Local Storage Token:', lsToken);
                // console.warn('Current User Token:', token);
                if (token && token !== lsToken) {
                    localStorage.setItem('auth_user_token', token);
                    return token;
                } else {
                    return lsToken;
                }
            }
            return null;
        }

    }
});
